import { ReactNode } from "react";

import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import PageInfoHeader from "ds/components/PageInfoHeader";

type PersonalSettingsGroupsPageLayoutProps = {
  children: ReactNode;
};

const PersonalSettingsGroupsPageLayout = ({ children }: PersonalSettingsGroupsPageLayoutProps) => {
  const { accountName } = useTypedContext(AccountContext);

  useTitle(`Personal Settings · IdP Groups · ${accountName}`);

  return (
    <>
      <PageInfoHeader title="IdP Groups" />
      {children}
    </>
  );
};

export default PersonalSettingsGroupsPageLayout;
